import { parseQueryParams } from '@/utils/api.util';
import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';

export const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    accept: 'application/json',
    'content-type': 'application/json'
  }
});

axiosInstance.defaults.transformResponse = [
  (data, headers) => {
    if (data && headers['content-type'].includes('application/json')) {
      return camelcaseKeys(JSON.parse(data), { deep: true });
    }
    return data;
  }
];

axiosInstance.defaults.transformRequest = [
  (data, headers) => {
    const contentType = headers['Content-Type'] as string | undefined;
    if (data && contentType?.includes('application/json')) {
      return JSON.stringify(snakecaseKeys(data, { deep: true }));
    }
    return data;
  }
];

export const setupInterceptors = (
  getAccessTokenSilently: () => Promise<string>
): SetupInterceptorsReturn => {
  const requestInterceptor = axiosInstance.interceptors.request.use(
    async (config) => {
      if (config?.params) {
        config.params = parseQueryParams(config.params);
      }

      try {
        const accessToken = await getAccessTokenSilently();
        config.headers.Authorization = `Bearer ${accessToken}`;
      } catch (_e) {
        config.headers.Authorization = undefined;
      }

      return config;
    }
  );

  const clear = () => {
    axiosInstance.interceptors.request.eject(requestInterceptor);
  };

  return {
    requestInterceptors: [requestInterceptor],
    clear
  };
};

type SetupInterceptorsReturn = {
  responseInterceptors?: number[];
  requestInterceptors?: number[];
  clear: () => void;
};
